<template>
  <router-link v-slot="{ href, isActive, navigate }" :to="to" custom>
    <li
      class="side-menu-child"
      :class="{ 'is-active': isActive }"
      @click="navigate"
    >
      <a
        :href="href"
        class="flex items-center gap-1 w-full min-w-0 text-inherit"
      >
        <span
          v-if="icon"
          class="inline-flex items-center justify-center w-4 h-4 rounded-sm bg-slate-100 dark:bg-slate-700 shrink-0"
        >
          <fluent-icon :icon="icon" size="12" />
        </span>
        <span
          v-if="labelColor"
          class="inline-flex rounded-sm h-3 w-3.5 shrink-0 border border-slate-50 dark:border-slate-900"
          :style="{ backgroundColor: labelColor }"
        />
        <span
          :title="menuTitle"
          class="flex-1 min-w-0"
          :class="{ truncate: shouldTruncate }"
        >
          {{ label }}
        </span>
        <span
          v-if="showChildCount"
          class="side-menu-count"
          :class="{ 'is-zero': isCountZero }"
        >
          {{ childItemCount }}
        </span>
        <span
          v-if="warningIcon"
          class="inline-flex rounded-sm bg-slate-100 shrink-0"
        >
          <fluent-icon
            v-tooltip.top-end="$t('SIDEBAR.FACEBOOK_REAUTHORIZE')"
            :icon="warningIcon"
            size="12"
          />
        </span>
      </a>
    </li>
  </router-link>
</template>
<script>
export default {
  props: {
    to: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    labelColor: {
      type: String,
      default: '',
    },
    shouldTruncate: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: String,
      default: '',
    },
    warningIcon: {
      type: String,
      default: '',
    },
    showChildCount: {
      type: Boolean,
      default: false,
    },
    childItemCount: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    showIcon() {
      return {
        'overflow-hidden whitespace-nowrap text-ellipsis': this.shouldTruncate,
      };
    },
    isCountZero() {
      return this.childItemCount === 0;
    },
    menuTitle() {
      return this.shouldTruncate ? this.label : '';
    },
  },
};
</script>
<style lang="scss" scoped>

.menu-label {

  // d99d
  .nested & {
    font-size: 0.9em;
    font-weight: 300;
  }
  // .
}

</style>
